import clsx from 'clsx';

interface Props {
  /** Token symbol. May be null/empty for legacy deposit rows where the
   *  backend never recorded one — caller doesn't have to filter, we just
   *  render the generic placeholder. */
  symbol: string | null | undefined;
  size?: 14 | 18 | 24 | 28;
  className?: string;
}

/** Inline-SVG token logo. USDC blue · USDT green · fallback paper. */
export function AssetBadge({ symbol, size = 24, className }: Props) {
  const upper = (symbol ?? '').toUpperCase();
  if (upper === 'USDC' || upper === 'USDC.E' || upper === 'PUSD') {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        aria-hidden
        className={clsx('shrink-0', className)}
      >
        <circle cx="12" cy="12" r="11" fill="#2775CA" />
        <path
          d="M12 6.2v1.5c1.7 0 3 1.1 3 2.7h-1.5c0-.7-.7-1.2-1.5-1.2-1 0-1.6.5-1.6 1.1 0 .5.4.9 1.4 1.1l1 .2c1.5.3 2.4 1 2.4 2.3 0 1.5-1.2 2.6-2.8 2.7v1.4h-1v-1.4c-1.8-.1-3.1-1.2-3.1-2.8H10c0 .8.8 1.3 1.8 1.3 1.1 0 1.7-.5 1.7-1.1 0-.5-.4-.9-1.4-1.1l-1-.2c-1.6-.3-2.4-1.1-2.4-2.3 0-1.4 1.2-2.5 2.8-2.6V6.2h1Z"
          fill="#fff"
        />
      </svg>
    );
  }
  if (upper === 'USDT') {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        aria-hidden
        className={clsx('shrink-0', className)}
      >
        <circle cx="12" cy="12" r="11" fill="#26A17B" />
        <path
          d="M13.4 11.4V9.7h3.4V7.4H7.2v2.3h3.4v1.7c-2.7.1-4.7.7-4.7 1.4 0 .7 2 1.3 4.7 1.4v5.3h2.8v-5.3c2.7-.1 4.7-.7 4.7-1.4 0-.7-2-1.3-4.7-1.4Zm0 2.4c-.1 0-.6 0-1.4 0s-1.3 0-1.4 0c-2.3-.1-4-.4-4-.8 0-.4 1.7-.7 4-.8v1.4c.2 0 .8 0 1.4 0 .7 0 1.3 0 1.4 0v-1.4c2.3.1 4 .4 4 .8 0 .4-1.7.7-4 .8Z"
          fill="#fff"
        />
      </svg>
    );
  }
  return (
    <span
      style={{ width: size, height: size }}
      className={clsx(
        'inline-flex shrink-0 items-center justify-center rounded-full bg-pb-paper2 text-[10px] font-bold text-tg-hint',
        className,
      )}
      aria-hidden
    >
      {upper.slice(0, 3)}
    </span>
  );
}
